export const DELETE = 'DELETE';
export const MUTES = 'MUTES';
export const WAVEFORM = 'WAVEFORM';
